<template>
    <v-dialog max-width="1200px" v-model="isOpenFilterDialog" persistent>
        <v-form>
            <v-card>
                <v-card-title primary-title>
                    <div
                        v-if="$vuetify.breakpoint.xs"
                        class="primary--text text-overline ml-2"
                    >
                        <v-icon left> mdi-magnify </v-icon>
                        Filtros de búsqueda
                    </div>
                    <div
                        v-else
                        class="font-weight-light primary--text text-h4 ml-2"
                    >
                        <v-icon large left> mdi-magnify </v-icon>
                        Filtros de búsqueda
                    </div>
                </v-card-title>
                <v-divider class="test"></v-divider>
                <v-card-text>
                    <v-row>
                        <v-col md="5" cols="12">
                            <v-card outlined class="px-4">
                                <v-row>
                                    <v-col md="12" class="mt-md-1">
                                        <h4
                                            class="
                                                font-weight-light
                                                primary--text
                                            "
                                        >
                                            Búsqueda por Fecha
                                        </h4>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="false"
                                    transition="scale-transition"
                                    offset-y
                                    min-width="auto"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-combobox
                                            :class="
                                                dataForm.dateFilter.length > 0
                                                    ? 'mt-2'
                                                    : 'mt-2 mb-2'
                                            "
                                            v-model="dataForm.dateFilter"
                                            :items="dataForm.dateFilter"
                                            multiple
                                            readonly
                                            clearable
                                            :label="
                                                dataForm.dateFilter.length > 0
                                                    ? 'Rango Seleccionado'
                                                    : 'Este Mes'
                                            "
                                            prepend-icon="mdi-calendar"
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <template
                                                v-slot:selection="{ item }"
                                            >
                                                <v-icon
                                                    v-if="
                                                        dataForm.dateFilter.indexOf(
                                                            item
                                                        ) == 1
                                                    "
                                                    >mdi-chevron-triple-right</v-icon
                                                >
                                                <v-chip
                                                    color="deep-purple"
                                                    dark
                                                >
                                                    <v-icon size="15" left>
                                                        mdi-update
                                                    </v-icon>
                                                    {{ item }}
                                                </v-chip>
                                            </template>
                                        </v-combobox>
                                    </template>
                                    <v-date-picker
                                        class="d-flex justify-center"
                                        range
                                        v-model="dataForm.dateFilter"
                                    >
                                        <v-row
                                            class="
                                                mt-md-n8
                                                d-flex
                                                justify-center
                                            "
                                        >
                                            <v-col
                                                cols="6"
                                                class="d-flex justify-center"
                                            >
                                                <v-btn
                                                    outlined
                                                    @click="setToday()"
                                                    color="yellow darken-3"
                                                >
                                                    Hoy
                                                    <v-icon right dark>
                                                        mdi-calendar-today
                                                    </v-icon>
                                                </v-btn>
                                            </v-col>
                                            <v-col
                                                cols="6"
                                                class="d-flex justify-center"
                                            >
                                                <v-btn
                                                    outlined
                                                    @click="setNull()"
                                                    color="red darken-1"
                                                >
                                                    Borrar
                                                    <v-icon right dark>
                                                        mdi-delete-clock-outline
                                                    </v-icon>
                                                </v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-date-picker>
                                </v-menu>
                            </v-card>
                        </v-col>
                        <v-col md="7" cols="12">
                            <v-card outlined class="px-4">
                                <v-row>
                                    <v-col md="12" class="mt-1">
                                        <h4
                                            class="
                                                font-weight-light
                                                primary--text
                                            "
                                        >
                                            Búsqueda por Comercial
                                        </h4>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row no-gutters>
                                    <v-col md="6" cols="12">
                                        <v-combobox
                                            :class="
                                                dataForm.selectedTipoComercial
                                                    ? 'mt-2'
                                                    : 'mt-2 mb-2'
                                            "
                                            v-model="
                                                dataForm.selectedTipoComercial
                                            "
                                            :items="tipoComercial"
                                            item-text="human"
                                            item-value="encoded"
                                            :return-object="false"
                                            clearable
                                            label="Tipo de comercial"
                                            prepend-icon="mdi-account-convert"
                                        >
                                            <template
                                                v-slot:selection="{ item }"
                                            >
                                                <v-chip
                                                    color="orange accent-3"
                                                    dark
                                                >
                                                    {{
                                                        item
                                                            .toLowerCase()
                                                            .replace(
                                                                /\w/,
                                                                (firstLetter) =>
                                                                    firstLetter.toUpperCase()
                                                            )
                                                    }}
                                                </v-chip>
                                            </template>
                                        </v-combobox>
                                    </v-col>
                                    <v-col md="6" cols="12">
                                        <v-combobox
                                            :class="
                                                dataForm.stateComercial
                                                    ? 'mt-2'
                                                    : 'mt-2 mb-2'
                                            "
                                            v-model="dataForm.stateComercial"
                                            :items="estadoComercial"
                                            item-text="human"
                                            item-value="encoded"
                                            :return-object="false"
                                            clearable
                                            label="Estado del Comercial"
                                            prepend-icon="mdi-state-machine"
                                        >
                                            <template
                                                v-slot:selection="{ item }"
                                            >
                                                <v-chip
                                                    color="orange accent-3"
                                                    dark
                                                >
                                                    {{
                                                        item
                                                            .toLowerCase()
                                                            .replace(
                                                                /\w/,
                                                                (firstLetter) =>
                                                                    firstLetter.toUpperCase()
                                                            )
                                                    }}
                                                </v-chip>
                                            </template>
                                        </v-combobox>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn @click="submit()" depressed color="primary">
                        Buscar
                    </v-btn>
                    <v-btn @click="closeFilterDialog()" text color="red">
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: 'ComercialesTableFilterDialog',
    data: () => ({
        menu: false,
        dataForm: {
            dateFilter: [],
            stateComercial: null,
            selectedTipoComercial: null,
        },
    }),
    computed: {
        isOpenFilterDialog: {
            get() {
                return this.$store.state.gerencia.isOpenFilterDialog;
            },
            set(val) {
                this.$store.commit('gerencia/isOpenFilterDialog', val);
            },
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        estadoComercial() {
            return JSON.parse(localStorage.getItem('opciones')).cuenta.estado;
        },
        tipoComercial() {
            return JSON.parse(localStorage.getItem('opciones')).cuenta
                .tipoComercial;
        },
    },
    methods: {
        submit() {
            this.$emit('dataDateComercialForm', this.dataForm);
            this.closeFilterDialog();
        },
        ...mapActions('gerencia', ['getComercialesData']),
        // selectAll(){
        //     this.selectedComerciales = JSON.parse(
        //         JSON.stringify(this.comerciales.map((item) => { return {'id': item.id, 'nombre_completo': item.nombre_completo}  }))
        //         );
        // },
        closeFilterDialog() {
            this.$store.commit('gerencia/isOpenFilterDialog', false);
        },
        // deleteChip(item) {
        //     console.log( this.selectedComerciales.indexOf(item))
        //     this.selectedComerciales.splice(
        //         this.selectedComerciales.indexOf(item),
        //         1
        //     );
        // },
        setNull() {
            this.dataForm.dateFilter = [];
        },
        setToday() {
            this.dataForm.dateFilter = [];
            this.dataForm.dateFilter.push(
                new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                    .toISOString()
                    .substr(0, 10)
            );
        },
    },
    watch: {
        'dataForm.dateFilter': {
            handler(val) {
                if (
                    this.dataForm.dateFilter &&
                    this.dataForm.dateFilter.length == 2 &&
                    this.dataForm.dateFilter[0] > this.dataForm.dateFilter[1]
                ) {
                    let aux = this.dataForm.dateFilter[0];
                    this.dataForm.dateFilter[0] = this.dataForm.dateFilter[1];
                    this.dataForm.dateFilter[1] = aux;
                }
            },
        },
    },
};
</script>
